<template>
  <div>
    <ModalAlert
      :id="modalId"
      :variant="'default'"
      :title="$t('engine.aiGenerate.insufficientCredit.title', languageEngine)"
      :confirm="$t('engine.aiGenerate.insufficientCredit.btnTopUp', languageEngine)"
      :cancel="$t('engine.aiGenerate.insufficientCredit.btnCancel', languageEngine)"
      :confirmVariant="'ai-gradient'"
      :showCancel="true"
      :showClose="true"
      :noCloseOnEsc="true"
      :noCloseOnBackdrop="true"
      :showConfirm="false"
      @onConfirm="onConfirm"
      @onCancel="onCancel"
      @onClose="onCancel"
    >
      <template #description>
        <div class="ai-insufficient-credit-body">
          <div class="ai-insufficient-credit-warning p-gd-1 mb-gd-1">
            <div class="d-flex align-items-start gap-gd-1">
              <i class="far fa-info-circle align-self-start fs-16"></i>
              <span v-html=" $t('engine.aiGenerate.insufficientCredit.messageDemo', languageEngine)" class="fs-sa-16 fw-400"></span>
            </div>
          </div>
          <div class="ai-insufficient-credit-detail p-gd-2">
            <ul class="list-unstyled mb-0">
              <li class="d-flex align-items-center justify-content-start gap-gd-1 detail-item">
                <span class="title-label fs-sa-16 fw-400">{{ $t('engine.aiGenerate.insufficientCredit.lblServiceRate', languageEngine) }}</span>
                <span class="icon-container">
                  <img :src="require('@assets/images/icon/ai_generate_small.svg')" style="width: 12px; height: 12px">
                </span>
                <span class="fs-db-24 fw-400">{{ $helper.numeric.formatComma(payload.creditUsed) }}</span>
                <span class="fs-db-24 fw-500 text-makeweb-ai-gradient">Credits</span>
              </li>
              <li class="d-flex align-items-center justify-content-start gap-gd-1 detail-item">
                <span class="title-label fs-sa-16 fw-400">{{ $t('engine.aiGenerate.insufficientCredit.lblRemainingCredit', languageEngine) }}</span>
                <span class="icon-container">
                  <img :src="require('@assets/images/icon/ai_generate_small.svg')" style="width: 12px; height: 12px">
                </span>
                <span class="fs-db-24 fw-400">{{ $helper.numeric.formatComma(payload.creditRemaining) }}</span>
                <span class="fs-db-24 fw-500 text-makeweb-ai-gradient">Credits</span>
              </li>
            </ul>
          </div>
        </div>
      </template>
    </ModalAlert>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ModalAlert from "@components_system/Shared/Tools/ModalAlert/ModalAlert";

export default {
  name: "ModalAIInsufficientCredit",
  components: {
    ModalAlert,
  },
  data() {
    return {
      modalId: "modal-ai-insufficient-credit",
    };
  },
  props: {
    creditAvailable: {
      type: Number,
      default: 0
    },
    creditUsed: {
      type: Number,
      default: 0
    },
    creditRemaining: {
      type: Number,
      default: 0
    }
  },
  computed: {
    ...mapGetters({
      languageEngine: "design/userPreference/languageEngine",
      modalActive: "design/modals/modalActive",
      modalsID: "design/modals/modalsID",
      modals: "design/modals/modals",
      services: "design/page/services",
    }),
    modal() {
      if (!this.modalsID.includes(this.modalId)) return null;
      return this.modals[this.modalId];
    },
    payload() {
      return (this.modal && this.modal.payload) || { creditAvailable: this.creditAvailable, creditUsed: this.creditUsed };
    },
  },
  methods: {
    openModal() {
      this.$bvModal.show(this.modalId);
    },
    onConfirm() {
      this.$bvModal.hide(this.modalId);
      const url = this.services.webbuilderCmsUrl + "?option=cms&cmsUrl=page/makewebeasy-ai-credit/view";
      window.open(url, "_blank");
      this.$store.dispatch("design/modals/callback", {
        key: this.modalId,
        clear: true,
        func: "confirmed",
        data: {},
      });
    },
    onCancel() {
      this.$store.dispatch("design/modals/callback", {
        key: this.modalId,
        clear: true,
        func: "cancelled",
        data: {},
      });
      this.$bvModal.hide(this.modalId);
    },
  },
  watch: {
    modalActive: {
      handler(next) {
        if (next == this.modalId) {
          this.openModal();
        }
      },
    },
  },
};
</script>
<style lang="scss" scoped>
#modal-ai-insufficient-credit{
  .ai-insufficient-credit-body {
    .ai-insufficient-credit-warning {
        padding: 8px;
        border-radius: 6px;
        background: #FFF7DF;
        color: #9E4C00;
    }
    .ai-insufficient-credit-detail{
      background-color: #F8F9FA;
      padding:16px;
      border-radius: 16px;
      .detail-item{
        .title-label{
          width: 160px;
        }
      }
    }
  }

}
</style>